import React from 'react';

/**
 * A custom hook for keeping track of current screen width
 * Inspired by https://stackoverflow.com/a/19014495
 */
const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = React.useState(0);
  React.useLayoutEffect(() => {
    const updateWidth = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', updateWidth);
    updateWidth();
    return () => window.removeEventListener('resize', updateWidth);
  }, []);
  return windowWidth;
};

export default useWindowWidth;
